/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Withdrawal
 */
export interface Withdrawal {
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    tradeDate: string;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    portfolioName?: string;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    householdName?: string;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    cashflowDate: string;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    portfolioTargetEndDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    portfolioTaxType?: string;
    /**
     * 
     * @type {number}
     * @memberof Withdrawal
     */
    withdrawalTaxRate?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Withdrawal
     */
    manuallySetWithdrawalTaxRate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    factorGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    withdrawalStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    withdrawalStatusUpdatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    frequencyType?: string;
    /**
     * 
     * @type {number}
     * @memberof Withdrawal
     */
    yearlyInflationRate?: number;
    /**
     * 
     * @type {string}
     * @memberof Withdrawal
     */
    inflationStartDate?: string;
    /**
     * 
     * @type {number}
     * @memberof Withdrawal
     */
    cashflowUnadjustedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof Withdrawal
     */
    cashflowInflationMultiplier?: number;
    /**
     * 
     * @type {number}
     * @memberof Withdrawal
     */
    cashflowInflatedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof Withdrawal
     */
    cashflowGrossInflatedAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof Withdrawal
     */
    cashflowFinalAmount?: number;
}

/**
 * Check if a given object implements the Withdrawal interface.
 */
export function instanceOfWithdrawal(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "cashflowDate" in value;

    return isInstance;
}

export function WithdrawalFromJSON(json: any): Withdrawal {
    return WithdrawalFromJSONTyped(json, false);
}

export function WithdrawalFromJSONTyped(json: any, ignoreDiscriminator: boolean): Withdrawal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tradeDate': json['trade_date'],
        'pId': json['p_id'],
        'portfolioName': !exists(json, 'portfolio_name') ? undefined : json['portfolio_name'],
        'householdName': !exists(json, 'household_name') ? undefined : json['household_name'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'cashflowDate': json['cashflow_date'],
        'portfolioTargetEndDate': !exists(json, 'portfolio_target_end_date') ? undefined : json['portfolio_target_end_date'],
        'portfolioTaxType': !exists(json, 'portfolio_tax_type') ? undefined : json['portfolio_tax_type'],
        'withdrawalTaxRate': !exists(json, 'withdrawal_tax_rate') ? undefined : json['withdrawal_tax_rate'],
        'manuallySetWithdrawalTaxRate': !exists(json, 'manually_set_withdrawal_tax_rate') ? undefined : json['manually_set_withdrawal_tax_rate'],
        'factorGuid': !exists(json, 'factor_guid') ? undefined : json['factor_guid'],
        'withdrawalStatus': !exists(json, 'withdrawal_status') ? undefined : json['withdrawal_status'],
        'withdrawalStatusUpdatedAt': !exists(json, 'withdrawal_status_updated_at') ? undefined : json['withdrawal_status_updated_at'],
        'frequencyType': !exists(json, 'frequency_type') ? undefined : json['frequency_type'],
        'yearlyInflationRate': !exists(json, 'yearly_inflation_rate') ? undefined : json['yearly_inflation_rate'],
        'inflationStartDate': !exists(json, 'inflation_start_date') ? undefined : json['inflation_start_date'],
        'cashflowUnadjustedAmount': !exists(json, 'cashflow_unadjusted_amount') ? undefined : json['cashflow_unadjusted_amount'],
        'cashflowInflationMultiplier': !exists(json, 'cashflow_inflation_multiplier') ? undefined : json['cashflow_inflation_multiplier'],
        'cashflowInflatedAmount': !exists(json, 'cashflow_inflated_amount') ? undefined : json['cashflow_inflated_amount'],
        'cashflowGrossInflatedAmount': !exists(json, 'cashflow_gross_inflated_amount') ? undefined : json['cashflow_gross_inflated_amount'],
        'cashflowFinalAmount': !exists(json, 'cashflow_final_amount') ? undefined : json['cashflow_final_amount'],
    };
}

export function WithdrawalToJSON(value?: Withdrawal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade_date': value.tradeDate,
        'p_id': value.pId,
        'portfolio_name': value.portfolioName,
        'household_name': value.householdName,
        'portfolio_guid': value.portfolioGuid,
        'cashflow_date': value.cashflowDate,
        'portfolio_target_end_date': value.portfolioTargetEndDate,
        'portfolio_tax_type': value.portfolioTaxType,
        'withdrawal_tax_rate': value.withdrawalTaxRate,
        'manually_set_withdrawal_tax_rate': value.manuallySetWithdrawalTaxRate,
        'factor_guid': value.factorGuid,
        'withdrawal_status': value.withdrawalStatus,
        'withdrawal_status_updated_at': value.withdrawalStatusUpdatedAt,
        'frequency_type': value.frequencyType,
        'yearly_inflation_rate': value.yearlyInflationRate,
        'inflation_start_date': value.inflationStartDate,
        'cashflow_unadjusted_amount': value.cashflowUnadjustedAmount,
        'cashflow_inflation_multiplier': value.cashflowInflationMultiplier,
        'cashflow_inflated_amount': value.cashflowInflatedAmount,
        'cashflow_gross_inflated_amount': value.cashflowGrossInflatedAmount,
        'cashflow_final_amount': value.cashflowFinalAmount,
    };
}

